import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const sliceName = "loadingSlice";

const initialState = {
  loadingBucket: [],
};

const addToLoadingBucket = (state, { payload, type }) => {
  state.loadingBucket.push({
    id: payload.id,
    path: payload.path,
    aborted: payload.aborted,
  });
};

const removeFromLoadingBucket = (state, { payload, type }) => {
  const newLoadingBucket = [...state.loadingBucket].filter(
    (loadingElemenet) => loadingElemenet.id != payload.id
  );

  state.loadingBucket = newLoadingBucket;
};

//////////////////////////////////////////////////////////////// SLICE

const loadingSlice = createSlice({
  name: sliceName,
  initialState: initialState,
  reducers: { addToLoadingBucket, removeFromLoadingBucket },
  extraReducers: (builder) => {},
});

export const asyncActions = {};
export const actions = loadingSlice.actions;
export default loadingSlice.reducer;
